import { Routes, Route } from "react-router-dom";
import Apartaments from "./screens/Apartaments";
import SingleApartament from "./screens/SingleApartament";
import AllApartaments from "./screens/AllApartaments";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Apartaments/>}/>
      <Route path="/apartamenty" element={<AllApartaments/>}/>
      <Route path="/dynamic" element={<SingleApartament/>}/>
    </Routes>
  )
}

export default App;
